import { render, staticRenderFns } from "./cockpit1.vue?vue&type=template&id=2a4e1d12"
import script from "./cockpit1.vue?vue&type=script&lang=js"
export * from "./cockpit1.vue?vue&type=script&lang=js"
import style0 from "./cockpit1.vue?vue&type=style&index=0&id=2a4e1d12&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports